// extracted by mini-css-extract-plugin
export default {"loading":"lotteryRecordSearch_loading__S-86s","pcWrap":"lotteryRecordSearch_pcWrap__ZCQVF"};